import { render, staticRenderFns } from "./UserStatusBadge.vue?vue&type=template&id=67e09a1e&"
import script from "./UserStatusBadge.vue?vue&type=script&lang=ts&"
export * from "./UserStatusBadge.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports